import { HTMLAttributes } from 'react'
import { Tooltip } from 'react-tooltip'
import cn from 'classnames'

import s from './QuestionmarkTooltip.module.scss'

interface IQuestionmarkTooltipProps extends HTMLAttributes<HTMLDivElement> {
  imgClassName?: string
  tooltipClassName?: string
  border?: string
  arrowColor?: string
  delayHide?: number
  place?: 'top' | 'right' | 'bottom' | 'left'
  anchorSelect: string
  content?: string
  width?: string | number
  height?: string | number
}

const QuestionmarkTooltip = ({
  anchorSelect,
  children,
  className,
  imgClassName,
  tooltipClassName,
  border = '1px solid rgba(166, 232, 205, 0.9)',
  arrowColor = 'white',
  delayHide = 300,
  place = 'bottom',
  content = '',
  width = '20px',
  height = '20px',
}: IQuestionmarkTooltipProps) => {
  return (
    <div className={cn(s.tooltipContainer, className)}>
      <img
        src="/puppy/info.svg"
        className={cn(anchorSelect, imgClassName)}
        alt="questionmark-tooltip"
        width={width}
        height={height}
      />
      <Tooltip
        id="puppy-questionmark"
        anchorSelect={`.${anchorSelect}`}
        place={place}
        className={cn(s.tooltip, tooltipClassName)}
        border={border}
        arrowColor={arrowColor}
        delayHide={delayHide}
        content={content}
      >
        {children}
      </Tooltip>
    </div>
  )
}

export default QuestionmarkTooltip
